// extracted by mini-css-extract-plugin
module.exports = {"Container":"TagGroup_Container__3uATI"};